import axios from 'axios';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL;

export const updateActionSelection = (id, id_company, value, configuration, accessToken ) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        },
        data: JSON.stringify({
            process: "company_action_selection_alter",
            action: "UPDATE",
            variables: JSON.stringify({
                id_company_action_selection: id,
                id_company,
                value,
                configuration
            }),
        }),
    });
};


export const fetchActionsSelectById = (id, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "company_action_selection_select",
            'action': "SELECT_ID_ACTION",
            'variables': JSON.stringify({ 'id_company_action_selection': id })
        })
    });
};
